/* eslint-disable no-console */
import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { BiometricService } from './biometric.service';

@Injectable({ providedIn: 'root' })
export class BiometricEnrollmentService {
  constructor(
    private readonly biometricService: BiometricService,
    private readonly alertController: AlertController,
    private readonly translateService: TranslateService
  ) {}

  public resetEnrollment(): void {
    this.biometricService.setDeclinedEnrollment();
    this.biometricService.clearStoredSecretMarker();
  }

  public async enrollUserBiometric(): Promise<void> {
    const isAvailable = await this.biometricService.isAvailable();
    if (!isAvailable) return;

    if (this.biometricService.hasAcceptedEnrollment()) return;

    const confirmed = await this.showEnrollmentAlert();

    if (confirmed) {
      this.biometricService.setAcceptedEnrollment();
    } else {
      this.biometricService.setDeclinedEnrollment();
    }
  }

  private async showEnrollmentAlert(): Promise<boolean> {
    return new Promise((resolve) => {
      this.alertController
        .create({
          header: this.translateService.instant('biometric.enrollment.header'),
          message: this.translateService.instant(
            'biometric.enrollment.message'
          ),
          buttons: [
            {
              text: this.translateService.instant(
                'biometric.enrollment.cancel'
              ),
              role: 'cancel',
              handler: () => {
                resolve(false);
              },
            },
            {
              text: this.translateService.instant(
                'biometric.enrollment.confirm'
              ),
              handler: () => {
                resolve(true);
              },
            },
          ],
        })
        .then((alert) => alert.present());
    });
  }
}
